import LoadableComponent from './../Loadable/index';
import Loadable from 'react-loadable';
import { L } from '../../lib/abpUtility';

export interface MSPRoute {
    path: string;
    exact?: boolean;
    name: string;
    permission?: string;
    title: string;
    // go to https://is.motion.abb.com.cn/sb/?path=/story/components-mois-icon-gallery--page
    // for icon options
    icon?: string;
    component?: Loadable.LoadableComponent;
    isLayout?: boolean;
    showInMenu: boolean;
    showInDashboard?: boolean;
    description?: string;
    strong?: boolean;
    children?: MSPRoute[];
}

export const appRouters: MSPRoute[] = [
    {
        path: '/',
        exact: true,
        name: 'home',
        permission: '',
        title: 'Home',
        component: LoadableComponent(() => import('../../components/Layout/AppLayout')),
        isLayout: true,
        showInMenu: false,
    },
    {
        path: '/IWorldDashboard',
        name: 'IWorldDashboard',
        title:  L('Pages.Workbench'),
        icon: 'abb_home',
        strong: false,
        showInMenu: false,
        component: LoadableComponent(() => import('../../scenes/IWorld/Dashboard/index')),
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        title: L('Pages.Workbench'),
        icon: 'abb_home',
        strong: true,
        showInMenu: true,
        component: LoadableComponent(() => import('../../scenes/Dashboard')),
    },
    {
        path: '/dashboard/Techinal',
        name: 'dashboardTechinal',
        title: '技术协议模块',
        strong: true,
        showInMenu: false,
        component: LoadableComponent(() => import('../../scenes/Dashboard/Techinal/index')),
    },
    {
        path: '/SmartConfigurator',
        permission: 'Pages.SmartConfigurator',
        title: '选型',
        name: 'Smart Configurator',
        icon: 'abb_motor',
        showInMenu: true,
        showInDashboard: true,
        children: [
            {
                path: '/NewModel',
                permission: 'Pages.SmartConfigurator.Lectotype.New',
                title: '新的选型',
                name: 'NewModel',
                description: '开始一个全新的选型',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/NewModel/components/createNewModel')),
            },
            {
                path: '/Drafts',
                permission: 'Pages.SmartConfigurator.Draft',
                title: '我的选型',
                name: 'Drafts',
                description: '继续未完成的选型工作',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Drafts')),
            },
            {
                path: '/HistoryModel',
                permission: 'Pages.SmartConfigurator.History',
                title: '所有选型',
                name: 'HistoryModel',
                description: '从您的选型历史中快速开始',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/HistoryModel')),
            },
            {
                path: '/ScSelectionQuery',
                permission: 'Pages.SmartConfigurator.ProductQuery',
                title: '产品查询',
                name: 'ScSelectionQuery',
                description: '独立的产品选型查询页面',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/ScSelectionQuery')),
            }
        ]
    },
    {
        path: '/OrderInputSystem',
        permission: 'OrderInputSystem',
        title: '订单中心',
        name: 'Order Input System',
        icon: 'abb_list-2',
        showInMenu: true,
        showInDashboard: true,
        children: [
            {
                path: '/orderInputSystem/soi',
                permission: 'Pages.OrderInputSystem.SOI',
                title: '自助下单中心',
                name: 'orderInputSystem',
                description: '提交您的订单',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/SOI')),
            },
            {
                path: '/orderInputSystem/soi/placeAnOrder/:id',
                permission: 'Pages.OrderInputSystem.SOI.Order',
                title: '下单',
                name: 'placeAnOrder',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/SOI/PlaceAnOrder')),
            },
            {
                path: '/orderInputSystem/soi/salesPlaceAnOrder/:id',
                permission: 'Pages.OrderInputSystem.SOI.Order',
                title: '下单',
                name: 'salesPlaceAnOrder',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/SOI/SalesPlaceAnOrder')),
            },
            {
                path: '/orderInputSystem/moi',
                permission: 'Pages.OrderInputSystem.MOI',
                title: '手动下单中心',
                name: 'orderInputSystem',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/MOI')),
            },
            {
                path: '/orderInputSystem/moi/placeAnOrder/:id',
                permission: 'Pages.OrderInputSystem.MOI.Order',
                title: '下单',
                name: 'placeAnOrder',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/MOI/PlaceAnOrder')),
            },
            // 148 费用车：勿单独做「报告&合格证」菜单页。购物车挂在原「质量文件」页上。
            // 旧链接 /orderInputSystem/motorCert 仍打到质量文件全功能页，避免误进瘦身页。
            {
                path: '/orderInputSystem/motorCert',
                permission: 'Pages.MotorCert.Download',
                title: '质量文件',
                name: 'orderInputSystemMotorCert',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/MotorCert')),
            },
            {
                path: '/orderInputSystem/motorCert/feeCart',
                permission: 'Pages.MotorCert.Download',
                title: '费用补充购物车',
                name: 'orderInputSystemMotorCertFeeCart',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/MotorCert/FeeCart')),
            },
            {
                path: '/orderInputSystem/orderChange',
                permission: '',
                title: '订单变更中心',
                name: 'orderInputSystemOrderChange',
                showInMenu: true,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/OrderChange')),
            },

            {
                path: '/orderInputSystem/orderChange/placeAnOrder/:id',
                permission: '',
                title: '已下单订单变更详情',
                name: 'orderInputSystemOrderChangeplaceAnOrder',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/OrderChange/PlaceAnOrder')),
            },
            {
                path: '/orderInputSystem/orderChange/OrderDetails/:id/:orderChangeOrderFormId?',
                permission: '',
                title: '订单变更详情',
                name: 'orderChangeDetails',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/OrderChange/OrderDetails')),
            },
            {
                path: '/OrderInputSystem/deliverynotessystem',
                permission: 'Pages.DeliveryNotesSystem.Create',
                title: '库存清单',
                name: 'deliverynotessystem',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/DeliveryNotesSystem')),
            },
            {
                path: '/OrderInputSystem/deliverynotessystem/:id/edit',
                permission: 'Pages.DeliveryNotesSystem.Update',
                title: '生成提货单',
                name: 'updateDeliverynotessystem',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/DeliveryNotesSystem/components/edit')),
            },
            {
                path: '/OrderInputSystem/deliverynotessystem/history',
                permission: 'Pages.DeliveryNotesSystem.Read',
                title: '发货历史记录',
                name: 'historydeliverynotessystem',
                showInMenu: true,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/DeliveryNotesSystem/components/history')),
            },
            {
                path: '/OrderInputSystem/deliverynotessystem/:id/details',
                permission: 'Pages.DeliveryNotesSystem.Details',
                title: '提货单详情',
                name: 'detailsDeliverynotessystem',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/DeliveryNotesSystem/components/details')),
            },
            {
                path: '/OrderInputSystem/deliverynotessystem/distributorDelivery',
                permission: 'Pages.DeliveryNotesSystem.DistributorDelivery',
                title: '分销商发货信息',
                name: 'distributorDelivery',
                showInMenu: true,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/DeliveryNotesSystem/components/distributorDelivery')),
            },
            {
                path: '/OrderInputSystem/deliverynotessystem/helpDelivery',
                permission: 'Pages.DeliveryNotesSystem.HelpDelivery',
                title: '协助发货',
                name: 'helpDelivery',
                showInMenu: true,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/DeliveryNotesSystem/components/helpDelivery')),
            },
            {
                path: '/OrderInputSystem/deliverynotessystem/helpDelivery/order',
                permission: 'Pages.DeliveryNotesSystem.HelpDelivery',
                title: '协助发货客户库存清单',
                name: 'helpDeliveryOrder',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/DeliveryNotesSystem/index')),
            },
            {
                path: '/OrderInputSystem/deliverynotessystem/helpDelivery/order/:id/edit',
                permission: 'Pages.DeliveryNotesSystem.HelpDelivery',
                title: '协助发货客户库存清单',
                name: 'helpDeliveryOrderEdit',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/DeliveryNotesSystem/components/edit')),
            },
            {
                path: '/OrderInputSystem/deliverynotessystem/splitOrder',
                permission: 'Pages.DeliveryNotesSystem.SplitOrder',
                title: '拆单历史记录',
                name: 'splitOrder',
                showInMenu: true,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/DeliveryNotesSystem/components/splitOrder')),
            },
            {
                path: '/OrderInputSystem/deliverynotessystem/specialShippingRequirement',
                permission: 'Pages.DeliveryNotesSystem.Read',
                title: 'DNS附件查询打印下载',
                name: 'specialShippingRequirement',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/DeliveryNotesSystem/components/specialShippingRequirement')),
            },
            {
                path: '/OrderVisualization',
                permission: 'Pages.OrderVisualization.OrderList',
                title: '订单状态查询',
                name: 'OrderVisualization',
                description: '订单状态查询',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/OrderVisualization')),
            },
            {
                path: '/OrderInputSystem/motorCert',
                permission: 'Pages.MotorCert.Download',
                title: '质量文件',
                name: 'MotorCert',
                description: '电机出厂试验报告与合格证下载',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/MotorCert')),
            },
            {
                path: '/OrderVisualization/MaintenancePlan',
                permission: 'Pages.OrderVisualization.MaintenancePlans',
                title: '计划出库日维护',
                name: 'MaintenancePlans',
                description: '计划出库日维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/OrderVisualization/MaintenancePlan')),
            },
            {
                path: '/OrderInputSystem/TaxRate',
                permission: 'Pages.OrderInputSystem.TaxRate',
                title: '税率维护',
                name: 'TaxRate',
                description: '税率维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/TaxRate')),
            },
            {
                path: '/orderInputSystem/moi/placeAnOrder/:id',
                permission: 'Pages.OrderInputSystem.MOI.Order',
                title: '下单',
                name: 'placeAnOrder',
                icon: 'tags',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/MOI/PlaceAnOrder')),
            },
            {
                path: '/orderInputSystem/export',
                permission: 'Pages.OrderInputSystem.ExportOrder',
                title: '外销订单中心',
                name: 'exportOrders',
                showInMenu: true,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/Export')),
            },
            {
                path: '/orderInputSystem/export/placeAnOrder/:id/:version?',
                permission: 'Pages.OrderInputSystem.ExportOrder.OrderDetails',
                title: '外销订单详情',
                name: 'exportOrders',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/Export/PlaceAnOrder')),
            },
            {
                path: '/orderInputSystem/export/ExportOrderChange/:id/:version?',
                permission: 'Pages.OrderInputSystem.ExportOrder.OrderDetails',
                title: '外销订单变更',
                name: 'exportOrders',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/Export/ExportOrderChange')),
            },
            {
                path: '/abcode',
                title: 'A/B代码关系查询',
                permission: 'Pages.OrderInputSystem.JINCodeVisitAB.View',
                name: 'ABCode',
                description: 'A/B代码关系查询',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/ABRelationship')),
            },
        ]
    },
    {
        path: '/Information',
        permission: 'Pages.ListPrice.Series',
        title: '价格表管理',
        name: 'Information',
        icon: 'abb_table',
        showInMenu: true,
        showInDashboard: true,
        children: [
            // {
            //     path: '/listPrice',
            //     permission: 'ListPrice',
            //     title: '面价',
            //     name: 'listPrice',
            //     description: '查询最新的面价表',
            //     showInMenu: true,
            //     showInDashboard: true,
            //     component: LoadableComponent(() => import('../../scenes/ListPrice')),
            // },
            // {
            //     path: '/listPrice/listPriceSeries',
            //     permission: 'Pages.ListPrice.Series',
            //     title: '产品系列',
            //     name: 'listPriceSeries',
            //     showInMenu: false,
            //     component: LoadableComponent(() => import('../../scenes/ListPrice/ListPriceSeries')),
            // },
            // {
            //     path: '/listPrice/listPriceSeries/listPriceBasicMotorAndVC',
            //     permission: 'Pages.ListPrice.Detail',
            //     title: '面价详情',
            //     name: 'listPriceBasicMotorAndVC',
            //     showInMenu: false,
            //     component: LoadableComponent(() => import('../../scenes/ListPrice/ListPriceSeries/ListPriceBasicMotorAndVC')),
            // },
            {
                path: '/listPrice/standard',
                permission: 'Pages.ListPrice.Platform',
                title: '标准面价',
                name: 'standardListPrice',
                description: '查询最新的标准面价表',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/ListPrice/Standard')),
            },
            {
                path: '/listPrice/standard/series',
                permission: 'Pages.ListPrice.Series',
                title: '标准面价系列',
                name: 'listPriceSeries',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/ListPrice/Standard/Series')),
            },
            {
                path: '/listPrice/standard/series/detail',
                permission: 'Pages.ListPrice.Detail',
                title: '标准面价详情',
                name: 'detail',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/ListPrice/Standard/Series/Detail')),
            },
            {
                path: '/listPrice/standard/series/history',
                permission: 'Pages.ListPrice.Detail',
                title: '标准面价历史',
                name: 'history',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/ListPrice/Standard/Series/History')),
            },
            {
                path: '/listPrice/jin',
                permission: 'Pages.ListPrice.Detail.Read.Export1D',
                title: '境界代码面价',
                name: 'JINListPrice',
                description: '查询最新的境界代码价表',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/ListPrice/JIN')),
            },
            {
                path: '/listPrice/jin/series',
                permission: 'Pages.ListPrice.Series',
                title: '境界代码系列',
                name: 'JINListPriceSeries',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/ListPrice/JIN/Series')),
            },
            {
                path: '/listPrice/jin/series/detail',
                permission: 'Pages.ListPrice.Detail',
                title: '境界面价详情',
                name: 'JINListPriceSeriesDetail',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/ListPrice/JIN/Series/Detail')),
            },
            {
                path: '/listPrice/jin/series/history',
                permission: 'Pages.ListPrice.Detail',
                title: '境界面价历史',
                name: 'JINListPriceSeriesHistory',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/ListPrice/JIN/Series/History')),
            },
            {
                path: '/listPrice/customer',
                permission: 'Pages.ListPrice.Detail.Read.Export1D',
                title: '客户化代码面价',
                name: 'CustomerListPrice',
                description: '查询最新的客户化代码价表',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/ListPrice/Customer')),
            },
            {
                path: '/listPrice/customer/series',
                permission: 'Pages.ListPrice.Series',
                title: '客户化代码系列',
                name: 'CustomerListPriceSeries',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/ListPrice/Customer/Series')),
            },
            {
                path: '/listPrice/customer/series/detail',
                permission: 'Pages.ListPrice.Detail',
                title: '客户化面价详情',
                name: 'CustomerListPriceSeriesDetail',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/ListPrice/Customer/Series/Detail')),
            },
            {
                path: '/listPrice/customer/series/history',
                permission: 'Pages.ListPrice.Detail',
                title: '客户化面价历史',
                name: 'CustomerListPriceSeriesHistory',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/ListPrice/Customer/Series/History')),
            },
            {
                path: '/StandardProductMaintenance',
                permission: 'Pages.SmartConfigurator.Maintenance.Std.Motor',
                title: '标准电机产品',
                name: 'StandardProductMaintenance',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/StandardProductMaintenance')),
            },
            {
                path: '/SystemAnnouncement',
                permission: '',
                title: '系统公告',
                name: 'SystemAnnouncement',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/SystemAnnouncement')),
            },
            {
                path: '/SystemAnnouncement/SystemAnnouncementDetails',
                permission: '',
                title: '系统公告详情',
                name: 'SystemAnnouncementDetails',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/SystemAnnouncement/SystemAnnouncementDetails')),
            },
            {
                path: '/SystemAnnouncement/ProductInformation',
                permission: '',
                title: '产品信息',
                name: 'ProductInformation',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/SystemAnnouncement/ProductInformation/index')),
            },
            {
                path: '/Information/ApprovalHistory',
                permission: 'Pages.ListPrice.Detail.Read.Export1D',
                title: '审批历史记录',
                name: 'ApprovalHistory',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Information/ApprovalHistory')),
            },
            {
                path: '/Information/PublicPriceList',
                permission: 'Pages.ListPrice.Series.Create',
                title: '公共价格表',
                name: 'PublicPriceList',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Information/PublicPriceList')),
            },
            {
                path: '/Information/PublicPriceList/Detail',
                permission: 'Pages.ListPrice.Series.Create',
                title: '公共价格表详情',
                name: 'PublicPriceListDetail',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Information/PublicPriceList/Detail')),
            }
        ]
    },
    {
        path: '/TODO',
        permission: '',
        title: '待办事项',
        name: 'TODO',
        icon: 'abb_check-mark-circle-2',
        showInMenu: true,
        showInDashboard: true,
        children: [
            {
                path: '/Approval',
                permission: 'Role.Approver',
                title: '审批中心',
                name: 'Approval',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Approval/ApprovalCenter')),
            },
            {
                path: '/Approval/PriceListApprovalList',
                permission: 'Pages.ListPrice.Approval',
                title: '价格表审批',
                name: 'PriceListApprovalList',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Approval/PriceListApprovalList')),
            },
            {
                path: '/Approval/PriceListApprovalList/detail/:id',
                permission: '',
                title: '价格表审批详情',
                name: 'PriceListApprovalListDetail',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Approval/PriceListApprovalList/Detail')),
            },
            {
                path: '/Approval/PriceListApprovalList/priceListDetail/:id',
                permission: '',
                title: '价格表详情',
                name: 'PriceListDetail',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Approval/PriceListApprovalList/PriceListDetail')),
            },
            {
                path: '/OrderInputSystem/motorCertManualUpload',
                permission: 'Pages.MotorCert.ManualUpload',
                title: '上传质量文件',
                name: 'MotorCertManualUpload',
                description: '上传合格证与出厂试验报告 PDF',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/MotorCert/ManualUpload')),
            },
            {
                path: '/Approval/OISDetails/:id/:auditStatus',
                permission: 'OrderInputSystem',
                title: '订单详情',
                name: 'OISDetails',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Approval/OISDetails')),
            },
            {
                path: '/HelpModel',
                permission: 'Pages.SmartConfigurator.HelpModel',
                title: '帮助选型',
                name: 'HelpModel',
                description: '帮助他人选型',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/HelpModel')),
            },
            {
                path: '/TransferEmployee',
                permission: 'Pages.Administration.TransferEmployee',
                title: '人员转移',
                name: 'TransferEmployee',
                description: '人员转移',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/TransferEmployee')),
            },
            {
                path: '/Approval/CustomVc/:id/details',
                permission: '',
                title: '自定义VC详情',
                name: 'CustomVcApprovalDetails',
                description: 'CustomVcApprovalDetails',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Approval/CustomVc/details')),
            },
            {
                path: '/Approval/CustomProductMaintenance/:id/details',
                permission: '',
                title: '自定义VC详情',
                name: 'CustomProductMaintenanceApprovalDetails',
                description: 'CustomProductMaintenanceApprovalDetails',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Approval/CustomerProductMaintenance/details')),
            },
            {
                permission: 'Pages.Taskapp.Design',
                path: '/taskapp/design',
                name: 'taskappDesign',
                title: '任务设计',
                component: LoadableComponent(() => import('../../scenes/TaskApp/Design')),
                showInMenu: true,
            },
            {
                permission: 'Pages.taskapp.application',
                path: '/taskapp/application',
                name: 'taskapp',
                title: '我的任务',
                component: LoadableComponent(() => import('../../scenes/TaskApp/Applications')),
                showInMenu: true,
            },


            {
                permission: '',
                path: '/taskapp/application/create',
                name: 'taskappCreate',
                title: 'Create Application',
                component: LoadableComponent(() => import('../../scenes/TaskApp/Applications/Create')),
                showInMenu: false,
            },
            {
                permission: '',
                path: '/taskapp/application/:id',
                name: 'taskappDetail',
                title: 'Application Detail',
                component: LoadableComponent(() => import('../../scenes/TaskApp/Applications/Detail')),
                showInMenu: false,
            },
            {
                permission: 'Pages.taskapp.task',
                path: '/taskapp/task',
                name: 'taskappTask',
                title: '任务列表',
                component: LoadableComponent(() => import('../../scenes/TaskApp/Tasks')),
                // component: TaskList,
                showInMenu: true,
            },
            {
                permission: '',
                path: '/taskapp/task/:applicationId',
                name: 'taskappTaskDetail',
                title: 'Task Detail',
                component: LoadableComponent(() => import('../../scenes/TaskApp/Tasks/Detail')),
                showInMenu: false,
            },
            {
                permission: 'Pages.taskapp.Administration',
                path: '/taskapp/administration/:useremail',
                name: 'taskapp',
                title: '任务指派',
                component: LoadableComponent(() => import('../../scenes/TaskApp/Administration')),
                showInMenu: true,
            },
            {
                permission: '',
                path: '/taskappall/task/:applicationId',
                name: 'taskappAllTaskDetail',
                title: 'Task Detail',
                component: LoadableComponent(() => import('../../scenes/TaskApp/Administration/Detail')),
                showInMenu: false,
            },
            {
                permission: 'Pages.taskapp.AuditTransferLogs',
                path: '/taskapp/audittransferlogs',
                name: 'taskapp',
                title: '流程操作记录',
                component: LoadableComponent(() => import('../../scenes/TaskApp/AuditTransferLogs')),
                showInMenu: true,
            },
            {
                permission: 'Pages.taskapp.ExecutionList',
                path: '/taskapp/executionlist',
                name: 'taskappExecutionList',
                title: '执行列表',
                component: LoadableComponent(() => import('../../scenes/TaskApp/ExecutionList')),
                showInMenu: true,
            },



            {
                path: '/Approval/ExportOrder/:id/details',
                permission: '',
                title: '自定义VC详情',
                name: 'ExportOrderApprovalDetails',
                description: 'ExportOrderApprovalDetails',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Approval/ExportOrder/details')),
            },
        ]
    },
    {
        path: '/Maintenance',
        permission: '',
        title: '数据维护',
        name: 'maintenance',
        icon: 'abb_edit',
        showInMenu: true,
        showInDashboard: true,
        children: [
            {
                path: '/TechnicalSpecifications',
                permission: 'Pages.SmartConfigurator.Maintenance.Techinal',
                title: '技术协议',
                name: 'TechnicalSpecifications',
                description: '查询技术协议规范',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/TechnicalSpecifications')),
            },
            {
                path: '/TechnicalSpecifications/:id/edit',
                permission: 'Pages.SmartConfigurator.Maintenance.Techinal',
                title: '技术协议编辑',
                name: 'TechnicalSpecifications',
                description: '编辑技术协议规范',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/TechnicalSpecifications/components/edit')),
            },
            {
                path: '/DomesticQuotation',
                permission: 'Pages.SmartConfigurator.Maintenance.Domestic',
                title: '国产报价',
                name: 'DomesticQuotation',
                description: '查询国产报价号',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/DomesticQuotation')),
            },
            {
                path: '/DomesticQuotation/:id',
                permission: 'Pages.SmartConfigurator.Maintenance.Domestic.Read',
                title: '国产报价详情',
                name: 'DomesticQuotationRead',
                description: '国产报价详情查看',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/DomesticQuotation/components/details')),
            },
            {
                path: '/DomesticQuotation/:id/edit',
                permission: 'Pages.SmartConfigurator.Maintenance.Domestic',
                title: '国产报价编辑',
                name: 'DomesticQuotation',
                description: '编辑国产报价号',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/DomesticQuotation/components/edit')),
            },
            {
                path: '/maintenance/basicMotorProduct',
                permission: 'Pages.SmartConfigurator.Maintenance.BasicMotorProduct.Read',
                title: '主机基础数据维护',
                name: 'maintenanceBasicMotorProduct',
                description: '主机基础数据维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/BasicMotorProduct')),
            },
            {
                path: '/CustomProductMaintenance',
                permission: 'Pages.SmartConfigurator.Maintenance.CustomMotors',
                title: '自定义电机',
                name: 'CustomProductMaintenance',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/CustomProductMaintenance')),
            },
            {
                path: '/maintenance/checkRules',
                permission: 'Pages.SmartConfigurator.Maintenance.CheckRules.Read',
                title: 'VC基础数据维护',
                name: 'maintenancebasicCheckRules',
                description: 'VC基础数据维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/CheckRules')),
            },
            {
                path: '/IndustryVCManage',
                permission: 'Pages.SmartConfigurator.Maintenance.Personal999',
                title: '行业999',
                name: 'IndustryVCManage',
                description: '基于行业或客户的个性化自定义VC',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/IndustryVCManage')),
            },
            {
                path: '/CustomVc',
                permission: 'Pages.SmartConfigurator.Maintenance.CustomVc',
                title: '自定义VC',
                name: 'CustomVc',
                description: 'CustomVc',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Maintenance/CustomVc')),
            },
            {
                path: '/CustomVc/:id/details',
                permission: 'Pages.SmartConfigurator.Maintenance.CustomVc',
                title: '自定义VC',
                name: 'CustomVc',
                description: 'CustomVc',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Maintenance/CustomVc/components/details')),
            },
            {
                path: '/SpeciaVc',
                permission: 'Pages.SmartConfigurator.Maintenance.SpeciaVc',
                title: '特殊VC',
                name: 'SpeciaVc',
                description: 'SpeciaVc',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Maintenance/SpeciaVc')),
            },
            {
                path: '/Category',
                permission: 'Pages.SmartConfigurator.Maintenance.Category',
                title: '品类',
                name: 'Category',
                description: 'Category',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Maintenance/Category')),
            },
            {
                path: '/maintenance/association',
                permission: 'Pages.Administration.Maintenance.Association.Read',
                title: '负责客户',
                name: 'maintenanceassociation',
                description: '维护个人名下的客户',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Customers/Association')),
            },
            {
                path: '/maintenance/distributorDelivery/deliveryTime',
                permission: 'Pages.Administration.Maintenance.DistributorDelivery.DeliveryTime',
                title: '限时发货',
                name: 'maintenancedistributordeliverydeliveryTime',
                description: '限制分销商发货时间段',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/DistributorDelivery/DeliveryTime')),
            },
            {
                path: '/maintenance/distributorDelivery/deliveryTime/:cusNo/details',
                permission: 'Pages.Administration.Maintenance.DistributorDelivery.DeliveryTime',
                title: '限时发货详情',
                name: 'maintenancedistributordeliverymaterialGroup',
                description: '查看为客户维护的限制发货时间段',
                showInMenu: false,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/DistributorDelivery/DeliveryTime/components/details')),
            },
            {
                path: '/maintenance/distributorDelivery/materialGroup',
                permission: 'Pages.Administration.Maintenance.DistributorDelivery.MaterialGroup',
                title: '物料组校验规则',
                name: 'maintenancedistributordeliverymaterialGroup',
                description: '限制客户在此物料规则中的订单不允许修改发货地址',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/DistributorDelivery/MaterialGroup')),
            },
            {
                path: '/maintenance/distributorDelivery/materialGroup/:cusNo/details',
                permission: 'Pages.Administration.Maintenance.DistributorDelivery.MaterialGroup',
                title: '物料组校验规则详情',
                name: 'maintenancedistributordeliverymaterialGroup',
                description: '查看为客户维护的物料组规则',
                showInMenu: false,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/DistributorDelivery/MaterialGroup/components/details')),
            },
            {
                path: '/maintenance/salesArea',
                permission: 'Pages.OrderInputSystem.Maintenance.SalesArea.Read',
                title: '销售区域',
                name: 'maintenancesalesArea',
                description: '销售区域基础数据维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/SalesArea')),
            },
            {
                path: '/maintenance/saleAreaUser',
                permission: 'Pages.OrderInputSystem.Maintenance.SalesAreaUser.Read',
                title: '销售区域关联销售',
                name: 'maintenanceSalesArea',
                description: '销售区域关联销售基础数据维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/SaleAreaUser')),
            },
            {
                path: '/CustomProductDeliveryMaintenance',
                permission: 'Pages.SmartConfigurator.Maintenance.BasicMotorProduct.Cycle',
                title: '电机交期',
                name: 'CustomProductDeliveryMaintenance',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/CustomProductDeliveryMaintenance')),
            },

            {
                path: '/maintenance/vcDeliveryCycle',
                permission: 'Pages.SmartConfigurator.Maintenance.CheckRules.Cycle',
                title: 'VC交期维护',
                name: 'maintenancestandardVcDeliveryCycle',
                description: 'VC交期维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/StandardVcDeliveryCycle')),
            },
            {
                path: '/maintenance/mainPlanReport',
                permission: 'Pages.SmartConfigurator.MainPlanReport',
                title: '主计划排产表',
                name: 'mainPlanReport',
                description: '主计划排产表',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/MainPlanReport')),
            },
            {
                path: '/maintenance/superimposedChangeValueReport',
                permission: 'Pages.SmartConfigurator.SuperimposedChangeValueReport',
                title: '叠加改取值表',
                name: 'superimposedChangeValueReport',
                description: '叠加改取值表',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/SuperimposedChangeValueReport')),
            },
            // {
            //     path: '/maintenance/standardMotorDeliveryMaintenance',
            //     permission: 'Pages.SmartConfigurator.Maintenance.CheckRules.Read',
            //     title: '标准电机交期维护',
            //     name: 'maintenancestandardMotorDeliveryMaintenance',
            //     description: '标准电机交期维护和查询',
            //     showInMenu: true,
            //     showInDashboard: true,
            //     component: LoadableComponent(() => import('../../scenes/StandardMotorDeliveryMaintenance')),
            // },
            // {
            //     path: '/industryVCManage/industryVCDeliveryCycle',
            //     permission: 'Pages.SmartConfigurator.Maintenance.CheckRules.Read',
            //     title: '行业VC交期维护',
            //     name: 'industryVCManageIndustryVCDeliveryCycle',
            //     description: '行业VC交期维护',
            //     showInMenu: true,
            //     showInDashboard: true,
            //     component: LoadableComponent(() => import('../../scenes/IndustryVCManage/IndustryVCDeliveryCycle')),
            // },
            // {
            //     path: '/personVcNNNMaintenance/personVCDeliveryCycle',
            //     permission: 'Pages.SmartConfigurator.Maintenance.CheckRules.Read',
            //     title: '自定义VC交期维护',
            //     name: 'personVcNNNMaintenancePersonVCDeliveryCycle',
            //     description: '自定义VC交期维护',
            //     showInMenu: true,
            //     showInDashboard: true,
            //     component: LoadableComponent(() => import('../../scenes/PersonVcNNNMaintenance/PersonVCDeliveryCycle')),
            // },
            {
                path: '/maintenance/vcLongShortCodeMapping',
                permission: 'Pages.SmartConfigurator.Maintenance.VcLongShortCodeMapping',
                title: '999小代码长短代码映射',
                name: 'maintenancebasicVcLongShortCodeMapping',
                description: '999小代码长短代码映射',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/VcLongShortCodeMapping')),
            },
            {
                path: '/maintenance/gradeBasicMotor',
                permission: 'Pages.OrderInputSystem.Maintenance.GradeBasicMotor.Read',
                title: '分类产品',
                name: 'maintenancegradeBasicMotor',
                description: '特定分类产品基础数据维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/GradeBasicMotor')),
            },
            {
                path: '/maintenance/gradeVc',
                permission: 'Pages.OrderInputSystem.Maintenance.GradeVc.Read',
                title: '分类Vc',
                name: 'maintenancegradeVc',
                description: '特定分类Vc基础数据维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/GradeVc')),
            },
            {
                path: '/maintenance/gradeLevelVc',
                permission: 'Pages.OrderInputSystem.Maintenance.GradeLevelVc.Read',
                title: '分类2级Vc',
                name: 'maintenancegradeLevelVc',
                description: '特定分类2级Vc基础数据维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/GradeLevelVc')),
            },
            {
                path: '/maintenance/gradeCustomer',
                permission: 'Pages.OrderInputSystem.Maintenance.GradeCustomer.Read',
                title: '分类最终客户',
                name: 'maintenanceGradeCustomer',
                description: '特定分类最终客户基础数据维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/GradeCustomer')),
            },
            {
                path: '/maintenance/CustomCode',
                permission: 'Pages.OrderInputSystem.Maintenance.CustomCode.Read',
                title: '客户化代码',
                name: 'maintenanceCustomCode',
                description: '客户化代码基础数据维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/CustomCode')),
            },
            {
                path: '/maintenance/SeriesApprover',
                permission: 'Pages.OrderInputSystem.Maintenance.SeriesApprover',
                title: '订单系列审批人',
                name: 'maintenanceSeriesApprover',
                description: '为特殊系列指定订单审批人',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/SeriesApprover')),
            },
            {
                path: '/orderInputSystem/countryRisk',
                permission: 'Pages.Administration.Maintenance.CountryRisk',
                title: '国家风险等级',
                name: 'CountryRisk',
                description: '国家风险等级维护',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/CountryRisk')),
            },
            {
                path: '/finalCustomer',
                permission: 'Pages.Administration.Maintenance.FinalCustomer',
                title: '二级客户',
                name: 'finalCustomerBasicMotor',
                description: '二级客户基础数据维护',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/FinalCustomer')),
            },
            {
                path: '/orderInputSystem/orderQuantityLimit',
                permission: 'Pages.OrderInputSystem.Maintenance.OrderQuantityLimit',
                title: '订单产品系列单行数量限制',
                name: 'CountryRisk',
                description: '订单产品系列单行数量限制',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Maintenance/OrderQuantityLimit')),
            },
            {
                path: '/logs/automateLogs',
                permission: 'Pages.OrderInputSystem.Maintenance.Logs.AutomateLogs',
                title: '自动化状态列表',
                name: 'automateLogs',
                description: '自动化状态列表',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Log/AutomateLogs')),
            },
            {
                path: '/orderInputSystem/export/ExportOrderDataPermissions',
                permission: 'Pages.OrderInputSystem.Maintenance.OISExportOrderDataPermissions',
                title: '外销订单访问配置',
                name: 'exportOrderDataPermissions',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/Export/ExportOrderDataPermissions')),
            },
            {
                path: '/SpecialOfferNo',
                permission: 'Pages.OrderInputSystem.Maintenance.SpecialOfferNo',
                title: '特价号',
                name: 'SpecialOfferNo',
                description: 'SpecialOfferNo',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Maintenance/SpecialOfferNo')),
            },
            {
                path: '/ExportOrderApprovalNodeConfiguration',
                permission: 'Pages.OrderInputSystem.Maintenance.ExportOrderApprovalNodeConfiguration',
                title: '外销订单审批流程节点配置',
                name: 'ExportOrderApprovalNodeConfiguration',
                description: 'ExportOrderApprovalNodeConfiguration',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Maintenance/ExportOrderApprovalNodeConfiguration')),
            },
            {
                path: '/GreenChannelReviewNo',
                permission: 'Pages.SmartConfigurator.GreenChannelReviewNo',
                title: '绿通评审号管理',
                name: 'GreenChannelReviewNo',
                description: '绿通评审号管理',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/SmartConfigurator/GreenChannelReviewNo')),
            },
            {
                path: '/ReplenishInventoryRemind',
                permission: 'Pages.SmartConfigurator.ReplenishInventoryRemind',
                title: '补库提醒',
                name: 'ReplenishInventoryRemind',
                description: '补库提醒查询',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/SmartConfigurator/ReplenishInventoryRemind')),
            },
            {
                path: '/maintenance/urgentGreenConfig',
                permission: 'Pages.Administration.Maintenance.UrgentConfiguration',
                title: '加急配置',
                name: 'maintenanceUrgentGreenConfig',
                description: '加急配置',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Maintenance/UrgentGreenConfig')),
            },
            {
                path: '/OrderInputSystem/ResetToZero',
                permission: 'Pages.OrderInputSystem.ResetToZero',
                title: '一键清零',
                name: 'ResetToZero',
                description: '一键清零',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/ResetToZero')),
            },
            {
                path: '/maintenance/industry',
                permission: 'Pages.OrderInputSystem.Maintenance.JINIndustry',
                title: '行业表',
                name: 'IndustryTable',
                description: '行业表查询',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/Industry')),
            },
            {
                path: '/maintenance/customer',
                permission: 'Pages.Administration.Maintenance.JINCustomer',
                title: '客户表',
                name: 'MaintenanceCustomer',
                description: '客户表查询',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/Customer')),
            },
            {
                path: '/maintenance/gcs',
                permission: 'Pages.SmartConfigurator.Maintenance.JINSupport',
                title: 'GCS境界支持',
                name: 'GCS',
                description: 'GCS境界支持',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/GCS')),
            },
            {
                path: '/maintenance/product',
                permission: 'Pages.SmartConfigurator.Maintenance.MotorSeries',
                title: '产品系列维护',
                name: 'product',
                description: '产品系列维护',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/Product')),
            },
        ]
    },
    {
        path: '/AutoApprove',
        permission: '',
        title: '自动审单',
        name: 'OisAutoApprove',
        icon: 'abb_motor',
        showInMenu: true,
        showInDashboard: false,
        children: [
            {
                path: '/OrderInputSystem/AutoApprove/CheckItem',
                permission: 'Pages.OrderInputSystem.AutoApprove.CheckItem',
                title: '检查项目',
                name: 'AutoApproveCheckItem',
                description: '检查项目',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/AutoApprove/CheckItem')),
            },
            {
                path: '/OrderInputSystem/AutoApprove/AutoApproveTask',
                permission: 'Pages.OrderInputSystem.AutoApprove.AutoApproveTask',
                title: '审单任务',
                name: 'AutoApproveTask',
                description: '审单任务',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/AutoApprove/AutoApproveTask')),
            },
            {
                path: '/OrderInputSystem/AutoApprove/CheckItemResult',
                permission: 'Pages.OrderInputSystem.AutoApprove.CheckItemResult',
                title: '检查结果',
                name: 'AutoApproveResult',
                description: '检查结果',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/AutoApprove/CheckItemResult')),
            },
            {
                path: '/OrderInputSystem/AutoApprove/OCRLog',
                permission: 'Pages.OrderInputSystem.AutoApprove.OCRLog',
                title: 'OCR任务记录',
                name: 'OCRLogTask',
                description: 'OCR任务记录',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/AutoApprove/OCRLog')),
            },
            {
                path: '/OrderInputSystem/AutoApprove/GreenChannelProject',
                permission: 'Pages.OrderInputSystem.AutoApprove.GreenChannelProject',
                title: '绿通项目评审',
                name: 'GreenChannelProject',
                description: '绿通项目评审',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/AutoApprove/GreenChannelProject')),
            },
            {
                path: '/OrderInputSystem/AutoApprove/GreenChannelYear',
                permission: 'Pages.OrderInputSystem.AutoApprove.GreenChannelYear',
                title: '绿通年度评审',
                name: 'GreenChannelYear',
                description: '绿通年度评审',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderInputSystem/AutoApprove/GreenChannelYear')),
            }
        ]
    },
    {
        path: '/Iworld',
        permission: '',
        title: L('Pages.IWorld'),
        name: 'iWorld',
        icon: 'abb_anchor',
        showInMenu: true,
        showInDashboard: true,
        children: [
            {
                path: '/IworldMSP',
                permission: 'Pages.IWorld.OrderDetail',
                title: L('Pages.IWorld.OrderInfomation'),
                name: 'IworldMSP',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfo/index')),
                children: [
                    {
                        path: '/IWorld/OrderInfo',
                        permission: 'Pages.IWorld.OrderDetail',
                        title: L('Pages.IWorld.OrderInfomation.Pending'),
                        name: 'IWorldOrderInfo',
                        showInMenu: true,
                        showInDashboard: false,
                        component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfo/index')),
                    },
                    {
                        path: '/IWorld/OrderInfoHistory',
                        permission: 'Pages.IWorld.OrderDetail',
                        title: L('Pages.IWorld.OrderInfomation.History'),
                        name: 'IWorldOrderHistory',
                        showInMenu: true,
                        showInDashboard: false,
                        component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfo/HistoryIndex')),
                    },
                ]
            },
            {
                path: '/IworldMSPChange',
                permission: 'Pages.IWorld.OrderDetail',
                title: L('Pages.IWorld.OrderChanges'),
                name: 'IworldMSPChange',
                showInMenu: true,
                showInDashboard: true,
                children: [
                    {
                        path: '/IWorld/OrderInfoModifyAudit',
                        permission: 'Pages.IWorld.OrderDetailAudit',
                        title: L('Pages.IWorld.OrderDetailAudit'),
                        name: 'IWorldOrderDetailAudit',
                        showInMenu: true,
                        showInDashboard: true,
                        component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfoModifyAudit')),
                    },
                    {
                        path: '/IWorld/OrderInfoLog',
                        permission: 'Pages.IWorld.OrderDetailModificationLog',
                        title:  L('Pages.IWorld.OrderDetailModificationLog'),
                        name: 'IWorldOrderDetailModificationLog',
                        showInMenu: true,
                        showInDashboard: true,
                        component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfoLog')),
                    },
                ]
            },
            {
                path: '/IworldMSPSetting',
                permission: 'Pages.IWorld.OrderDetail',
                title: L('Pages.IWorld.OrderSetting'),
                name: 'IworldMSPSetting',
                showInMenu: true,
                showInDashboard: true,
                children: [
                    {
                        path: '/IWorld/VarConfig',
                        permission: 'Pages.IWorld.VarConfig',
                        title: L('Pages.IWorld.VarConfig'),
                        name: 'IWorldVarConfig',
                        showInMenu: true,
                        showInDashboard: true,
                        component: LoadableComponent(() => import('../../scenes/IWorld/VarConfig/index'))
                    },
                    {
                        path: '/IWorld/CountrySalesRelation',
                        permission: 'Pages.IWorld.CountrySalesRelation',
                        title: L('Pages.IWorld.CountrySalesRelation'),
                        name: 'IWorldCountrySalesRelation',
                        showInMenu: true,
                        showInDashboard: true,
                        component: LoadableComponent(() => import('../../scenes/IWorld/CountrySalesRelation')),
                    },
                    {
                        path: '/IWorld/UserCustomerRelationship',
                        permission: 'Pages.IWorld.UserCustomerRelationship',
                        title: L('Pages.IWorld.UserCustomerRelationship'),
                        name: 'IWorldUserCustomerRelationship',
                        showInMenu: true,
                        showInDashboard: true,
                        component: LoadableComponent(() => import('../../scenes/IWorld/UserCustomerRelationship')),
                    },
                    {
                        path: '/IWorld/OperationLog',
                        permission: 'Pages.IWorld.OperationLog',
                        title: L('Pages.IWorld.OperationLog'),
                        name: 'IWorldOperationLog',
                        showInMenu: true,
                        showInDashboard: true,
                        component: LoadableComponent(() => import('../../scenes/IWorld/OperationLog')),
                    },
                    {

                        path: '/IWorld/EmailSendLog',
                        permission: 'Pages.IWorld.EmailSendLog',
                        title: L('Pages.IWorld.EmailSendLog'),
                        name: 'IWorldEmailSendLog',
                        showInMenu: true,
                        showInDashboard: true,
                        component: LoadableComponent(() => import('../../scenes/IWorld/EmailSendLog')),
                    },
                ]
            },
            // 后续研究 showInMenu 设置为false
            {
                path: '/IWorld/VarConfig',
                permission: 'Pages.IWorld.VarConfig',
                title: L('Pages.IWorld.VarConfig'),
                name: 'IWorldVarConfig',
                description: L('Pages.IWorld.VarConfig'),
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/IWorld/VarConfig/index')),
            },
            {
                path: '/IWorld/CountrySalesRelation',
                permission: 'Pages.IWorld.CountrySalesRelation',
                title: L('Pages.IWorld.CountrySalesRelation'),
                name: 'IWorldCountrySalesRelation',
                description: L('Pages.IWorld.CountrySalesRelation'),
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/IWorld/CountrySalesRelation')),
            },
            {
                path: '/IWorld/OrderInfo',
                permission: 'Pages.IWorld.OrderDetail',
                title: L('Pages.IWorld.OrderDetail'),
                name: 'IWorldOrderInfo',
                description: L('Pages.IWorld.OrderDetail'),
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfo/index')),
            },

            {
                path: '/IWorld/OrderInfoHistory',
                permission: 'Pages.IWorld.OrderDetail',
                title: L('Pages.IWorld.OrderInfomation.History'),
                name: 'IWorldOrderHistory',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfo/HistoryIndex')),
            },
            {
                path: '/IWorld/OrderInfoModifyAudit',
                permission: 'Pages.IWorld.OrderDetailAudit',
                title: L('Pages.IWorld.OrderDetailAudit'),
                name: 'IWorldOrderDetailAudit',
                description: L('Pages.IWorld.OrderDetailAudit'),
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfoModifyAudit')),
            },
            {
                path: '/IWorld/OrderInfoLog',
                permission: 'Pages.IWorld.OrderDetailModificationLog',
                title:  L('Pages.IWorld.OrderDetailModificationLog'),
                name: 'IWorldOrderDetailModificationLog',
                description:  L('Pages.IWorld.OrderDetailModificationLog'),
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfoLog')),
            },
            {
                path: '/IWorld/OperationLog',
                permission: 'Pages.IWorld.OperationLog',
                title: L('Pages.IWorld.OperationLog'),
                name: 'IWorldOperationLog',
                description: L('Pages.IWorld.OperationLog'),
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/IWorld/OperationLog')),
            },
            {
                path: '/IWorld/EmailSendLog',
                permission: 'Pages.IWorld.EmailSendLog',
                title: L('Pages.IWorld.EmailSendLog'),
                name: 'IWorldEmailSendLog',
                description: L('Pages.IWorld.EmailSendLog'),
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/IWorld/EmailSendLog')),
            },
            {
                        path: '/IWorld/UserCustomerRelationship',
                        permission: 'Pages.IWorld.UserCustomerRelationship',
                        title: L('Pages.IWorld.UserCustomerRelationship'),
                        name: 'IWorldUserCustomerRelationship',
                        showInMenu: false,
                        showInDashboard: false,
                        component: LoadableComponent(() => import('../../scenes/IWorld/UserCustomerRelationship')),
                    },
            // {
            //     path: '/IworldMSPManual',
            //     permission: 'Pages.IWorld.OrderDetail',
            //     title: L('Pages.IWorld.OrderManual'),
            //     name: 'IworldMSPManual',
            //     showInMenu: true,
            //     showInDashboard: false,
            // },
            // {
            //     path: '/IworldMSPDownLoad',
            //     permission: 'Pages.IWorld.OrderDetail',
            //     title: L('Pages.IWorld.OrderDownload'),
            //     name: 'IworldMSPDownLoad',
            //     showInMenu: true,
            //     showInDashboard: false
            // },
        ]
    },
    {
        path: '/IworldDetial',
        permission: '',
        title: L('Pages.IWorld.OrderInfomation'),
        name: 'iworld',
        icon: 'abb_list-2',
        showInMenu: true,
        showInDashboard: true,
        children: [
            {
                path: '/IworldDetial/OrderInfo',
                permission: 'Pages.IWorld.OrderDetail',
                title: L('Pages.IWorld.OrderInfomation.Pending'),
                name: 'IWorldOrderDetail',
                description: L('Pages.IWorld.OrderInfomation.Pending'),
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfo/index')),
            },

            {
                path: '/IworldDetial/OrderInfoHistory',
                permission: 'Pages.IWorld.OrderDetail',
                title: L('Pages.IWorld.OrderInfomation.History'),
                name: 'IWorldOrderDetailHistory',
                description: L('Pages.IWorld.OrderInfomation.History'),
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfo/HistoryIndex')),
            },
        ]
    },
    {
        path: '/IworldDetialChange',
        permission: '',
        title: L('Pages.IWorld.OrderChanges'),
        name: 'iworld',
        icon: 'abb_table',
        showInMenu: true,
        showInDashboard: true,
        children: [
            {
                path: '/IworldDetial/OrderInfo?type=TechnicalParameterModification',
                permission: 'Pages.IWorld.OrderDetail',
                title: L('Pages.IWorld.OrderDetail.TechnicalParameterModification'),
                name: 'IWorldOrderDetailTechnicalParameterModification',
                description: L('Pages.IWorld.OrderDetail.TechnicalParameterModification'),
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfo/index')),
            },
            {
                path: '/IworldDetial/OrderInfo?type=DeliveryDateModification',
                permission: 'Pages.IWorld.OrderDetail',
                title: L('Pages.IWorld.OrderDetail.DeliveryDateModification'),
                name: 'IWorldOrderDetailDeliveryDateModification',
                description: L('Pages.IWorld.OrderDetail.DeliveryDateModification'),
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfo/index')),
            },
            {
                path: '/IworldDetial/OrderInfo?type=PriceModification',
                permission: 'Pages.IWorld.OrderDetail',
                title: L('Pages.IWorld.OrderDetail.PriceModification'),
                name: 'IWorldOrderDetailPriceModification',
                description: L('Pages.IWorld.OrderDetail.PriceModification'),
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfo/index')),
            },
            {
                path: '/IworldDetial/OrderInfo?type=OrderCancel',
                permission: 'Pages.IWorld.OrderDetail',
                title: L('Pages.IWorld.OrderDetail.OrderCancel'),
                name: 'IWorldOrderDetailOrderCancel',
                description: L('Pages.IWorld.OrderDetail.OrderCancel'),
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfo/index')),
            },
            {
                path: '/IworldDetialChange/OrderInfoLog',
                permission: 'Pages.IWorld.OrderDetailModificationLog',
                title:  L('Pages.IWorld.OrderDetailModificationLog'),
                name: 'IWorldOrderDetailModificationLog',
                description:  L('Pages.IWorld.OrderDetailModificationLog'),
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/IWorld/OrderInfoLog')),
            },
        ]
    },
    // {
    //     path: '/IworldDetialManual',
    //     permission: '',
    //     title: L('Pages.IWorld.OrderManual'),
    //     name: 'iworld',
    //     icon: 'abb_motor',
    //     showInMenu: true,
    //     showInDashboard: true,
    // },
    // {
    //     path: '/IworldDetialDownLoad',
    //     permission: '',
    //     title: L('Pages.IWorld.OrderDownload'),
    //     name: 'iworld',
    //     icon: 'abb_edit',
    //     showInMenu: true,
    //     showInDashboard: true
    // },
    {
        path: '/SystemManagement',
        permission: '',
        title: '系统管理',
        name: '系统管理',
        icon: 'abb_controls-and-settings',
        showInMenu: true,
        showInDashboard: false,
        children: [
            {
                path: '/users',
                permission: 'Pages.Administration.Users',
                title: '用户管理',
                name: 'user',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Users')),
            },
            {
                path: '/users/logic',
                permission: 'Pages.Administration.Logic',
                title: '用户逻辑检查',
                name: 'user',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Users/components/logic')),
            },
            {
                path: '/roles',
                permission: 'Pages.Administration.Roles',
                title: '角色管理',
                name: 'role',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Roles')),
            },
            {
                path: '/customers',
                permission: 'Pages.Administration.Customer',
                title: '客户管理',
                name: 'customers',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Customers')),
            },
            {
                path: '/customers/eus',
                permission: 'Pages.Administration.Customer',
                title: '地址管理',
                name: 'eUs',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/Customers/EUs')),
            },
            {
                path: '/customers/:customerInfoCusNo/eus',
                permission: 'Pages.Administration.Customer',
                title: '地址',
                name: 'eUs',
                showInMenu: false,
                component: LoadableComponent(() => import('../../scenes/Customers/EUs')),
            },
            {
                path: '/customers/shippingAddress',
                permission: 'Pages.Administration.ShippingAddress',
                title: '收货地址',
                name: 'shippingAddress',
                showInMenu: true,
                component: LoadableComponent(() => import('../../scenes/Customers/ShippingAddress')),
            },
            {
                path: '/log/UserRoleChangeLogs',
                permission: 'Pages.Administration.Logs.UserRoleChangeLogs',
                title: '用户角色变更日志',
                name: 'UserRoleChangeLogs',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Log/UserRoleChangesLogs')),
            },
            {
                path: '/log/RolePermissionsChangeLogs',
                permission: 'Pages.Administration.Logs.RolePermissionsChangeLogs',
                title: '角色权限变更日志',
                name: 'RolePermissionsChangeLogs',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Log/RolePermissionsChangeLogs')),
            },
            {
                path: '/calendar',
                permission: 'Pages.Administration.Calendar',
                title: '日历',
                name: 'AdministrationCalendar',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Calendar')),
            },
            {
                path: '/holiday',
                permission: 'Pages.Administration.Holiday',
                title: '法定节假日',
                name: 'AdministrationHoliday',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Holiday')),
            },
            {
                path: '/log/SynchronizeSapRecords',
                permission: 'Pages.SmartConfigurator.Maintenance.SynchronizeSapRecord',
                title: 'SAP数据同步记录',
                name: 'logSynchronizeSapRecords',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Log/SynchronizeSapRecord')),
            },
            {
                path: '/log/Job',
                permission: 'Pages.SmartConfigurator.Maintenance.Job',
                title: '定时后台任务',
                name: 'Job',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/Log/Job')),
            }

        ]
    },
    {
        path: '/orderchecktoolrule',
        permission: 'Role.SuperGCS',
        title: 'VC检查规则维护',
        name: 'VC检查规则维护',
        icon: 'abb_edit',
        showInMenu: true,
        showInDashboard: false,
        children: [
            {
                path: '/numberwirescheckrules',
                permission: 'Role.SuperGCS',
                title: 'VC头数检查规则维护',
                name: 'numberwirescheckrules',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderchecktoolRule/NumberWiresCheckRules')),
            },
            {
                path: '/singlevcnotificationrules',
                permission: 'Role.SuperGCS',
                title: '单VC告知信息维护',
                name: 'singlevcnotificationrules',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderchecktoolRule/SingleVCNotificationRules')),
            },
            {
                path: '/doublevccheckrules',
                permission: 'Role.SuperGCS',
                title: '双VC检查规则维护',
                name: 'doublevccheckrules',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderchecktoolRule/DoubleVCCheckRules')),
            },
            {
                path: '/vcgroupcheckrules',
                permission: 'Role.SuperGCS',
                title: 'VC规则组检查维护',
                name: 'vcgroupcheckrules',
                showInMenu: true,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderchecktoolRule/VCGroupCheckRules')),
            },
        ]
    },
    {
        path: '/OrderDashboard',
        permission: 'Pages.OISDashbord',
        title: '订单汇总',
        name: 'Order Dashbord System',
        icon: 'abb_list-2',
        showInMenu: true,
        showInDashboard: true,
        children: [
            {
                path: '/OrderDashboard/list',
                permission: 'Pages.OISDashbord.OrderList',
                title: '订单汇总',
                name: 'OrderDashboard',
                description: '订单汇总',
                showInMenu: true,
                showInDashboard: true,
                component: LoadableComponent(() => import('../../scenes/OrderDashboard')),
            },
            {
                path: '/OrderDashboard/orderDetails/:id/:auditStatus',
                permission: 'Pages.OISDashbord.OrderList.OrderDetails',
                title: '订单详情',
                name: 'orderDetails',
                showInMenu: false,
                showInDashboard: false,
                component: LoadableComponent(() => import('../../scenes/OrderDashboard/orderDetails')),
            },
        ]
    },
    {
        path: '/LectoType/:id',
        permission: 'Pages.SmartConfigurator.Lectotype',
        title: '选型方式',
        name: 'LectoType',
        showInMenu: false,
        component: LoadableComponent(() => import('../../scenes/NewModel')),
    },
    {
        path: '/LectoType/Details/:id',
        title: '选型方式',
        name: 'LectoType',
        showInMenu: false,
        component: LoadableComponent(() => import('../../scenes/NewModel/components/lectoTypeDetails')),
    },
    {
        path: '/Approval/TechnologyAgreement/:id/:path',
        permission: 'Pages.SmartConfigurator.Lectotype',
        title: '技术协议审批',
        name: 'TechnologyAgreementApproval',
        showInMenu: false,
        component: LoadableComponent(() => import('../../scenes/Approval/TechnologyAgreement')),
    },
    {
        path: '/Approval/DomesticQuotation/:id/:path',
        permission: 'Pages.SmartConfigurator.Lectotype.Domestic.Approve',
        title: '国产报价审批',
        name: 'DomesticQuotationApproval',
        showInMenu: false,
        component: LoadableComponent(() => import('../../scenes/Approval/DomesticQuotation')),
    },
    {
        path: '/IndustryVCManage/IndustryVCDetails/:id',
        permission: 'Pages.SmartConfigurator.Maintenance.Personal999',
        title: '行业VC详情',
        name: 'IndustryVCDetails',
        showInMenu: false,
        component: LoadableComponent(() => import('../../scenes/IndustryVCManage/IndustryVCDetails')),
    },
    {
        path: '/exception?type=:code',
        permission: '',
        title: 'exception',
        name: 'exception',
        showInMenu: false,
        component: LoadableComponent(() => import('../../scenes/Exception')),
    }
];
export const routers = appRouters;
